let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("fhSab")).then(() => parcelRequire('kaBj2'));